const ConfigUrl = {
  appurl: "/",
  // apiurl: "https://endemoapi.zithas.com/api",
  // imageurl: "https://endemoapi.zithas.com",


  imageurl: "https://napi.zithas.com",
  apiurl: 'https://napi.zithas.com/api',
}

export default ConfigUrl